import { PickingStationEntity } from '@peritasai/repository';
import type { PickingStationDto } from '@peritasai/repository';

const STORAGE_KEY = 'periverse.buildCart.selectedStation';
const STATION_STATUSES = new Set(['Available', 'Busy', 'Offline']);

const isBrowser = () => typeof window !== 'undefined';

const isPickingStationDto = (value: unknown): value is PickingStationDto =>
  typeof value === 'object' &&
  value !== null &&
  typeof (value as Record<string, unknown>).id === 'string' &&
  typeof (value as Record<string, unknown>).name === 'string' &&
  STATION_STATUSES.has((value as Record<string, unknown>).status as string);

export const readStoredStation = (): PickingStationEntity | null => {
  if (!isBrowser()) return null;

  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    if (!isPickingStationDto(parsed)) return null;
    return new PickingStationEntity(parsed);
  } catch (error) {
    console.warn('Failed to read stored build-cart station', error);
    return null;
  }
};

export const writeStoredStation = (station: PickingStationEntity) => {
  if (!isBrowser()) return;

  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(station.toDTO()));
  } catch (error) {
    console.warn('Failed to persist build-cart station', error);
  }
};

export const clearStoredStation = () => {
  if (!isBrowser()) return;

  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear stored build-cart station', error);
  }
};
